import React, {CSSProperties, forwardRef} from 'react'
import {ButtonNew} from '@components/common/base/buttons'
import {TablerIcons} from '@components/common/icon-tabler/icon-tabler'

export interface ButtonProps {
  title?: React.ReactNode
  icon?: TablerIcons
  iconAfter?: TablerIcons
  hint?: React.ReactNode
  size?: 'sm' | 'md' | 'lg'
  color?: 'primary' | 'secondary' | 'notification-primary'
  disabled?: boolean
  onClick?: (e: React.MouseEvent) => void
  onMouseDown?: (e: React.MouseEvent) => void
  className?: string
  style?: CSSProperties
  children?: React.ReactNode
  pending?: boolean
  fitWidth?: boolean
}

export const SharedButton = forwardRef((props: ButtonProps, ref) => {
  const {
    title,
    icon,
    iconAfter,
    hint,
    size,
    color,
    disabled,
    onClick,
    onMouseDown,
    className,
    style,
    children,
    pending,
    fitWidth
  } = props
  return (
    <ButtonNew
      ref={ref}
      icon={icon}
      iconAfter={iconAfter}
      title={title}
      hint={hint}
      size={size}
      color={color}
      disabled={disabled}
      onClick={onClick}
      onMouseDown={onMouseDown}
      className={className}
      style={style}
      children={children}
      pending={pending}
      fitWidth={fitWidth}
    />
  )
})
